import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const VERIFY_INVITATION = gql`
  query verifyInvitation($token: String!) {
    verifyInvitation(token: $token) {
      message,
      data {
        role,
        email,
        name,
        managerFirstName,
        managerLastName,
        country{
            label
        value
        },
        city{
        label
        value},
        state{label
        value},
        contactNumber,
        primaryContactName,
        genre,
        bio,
        socialMedia {
          instagram,
          facebook,
          twitter,
          website,
          spotify,
          youtube,
        },
        profileImage,
        artistImage,
        managerImage,
        companyName,
        _id,
        artistId,
      },
    }
}`;
